export const theme = {
  token: {
    colorPrimary: '#ffb500',
    borderRadius: 2,
    fontFamily: 'Libre Franklin, sans-serif',
    colorSuccess: '#52c41a',
    colorWarning: '#ff6800',
    colorError: '#f5222d',
    colorInfo: '#1890ff',
  },
  components: {
    Message: {
      contentBg: '#ffffff',
      contentPadding: '10px 16px',
      borderRadiusLG: 2,
      fontSize: 14,
      fontFamily: 'Libre Franklin, sans-serif',
    },
    Button: {
      borderRadius: 2,
      fontFamily: 'Libre Franklin, sans-serif',
      colorPrimary: '#ffb500',
      colorTextLightSolid: '#ffffff',
    },
    Menu: {
      // Dark menu styles
      darkItemBg: '#1034b4',
      darkSubMenuItemBg: '#1034b4',
      darkPopupBg: '#1034b4',
      darkItemColor: '#ffffff',
      darkItemSelectedBg: '#ffb500',
      darkItemSelectedColor: '#ffffff',
      darkItemHoverBg: '#ffb500',
      darkItemHoverColor: '#ffffff',
      // Horizontal menu (header) styles
      horizontalItemBg: '#1034b4',
      horizontalItemSelectedBg: '#ffb500',
      horizontalItemSelectedColor: '#ffffff',
      horizontalItemHoverBg: '#ffb500',
      horizontalItemHoverColor: '#ffffff',
      subMenuItemBg: '#1034b4',
      popupBg: '#1034b4',
      // Font
      fontFamily: 'Knockout-HTF29-JuniorLiteweight, sans-serif',
      fontSize: 18,
      itemColor: '#ffffff',
    },
    Segmented: {
      itemColor: '#000000',
      itemSelectedColor: '#000000',
    },
  },
};
